import { useCallback, useRef } from 'react';
import { DataGrid, useGridConfig } from '@eo/shared';

import {
  makeTeamCategoriesGridConfig,
  makeTeamClientsGridConfig,
  type TeamClientRow,
} from './config/gridConfig';
import { formatHours, teamCategoryRows } from './helpers';
import { MemberCapacity } from './MemberCapacity';
import type { MemberSummaryProps, TeamCategoryRow } from './types';

export function MemberSummary({ report, staffId, meId }: MemberSummaryProps) {
  const member = report.users.find((s) => s.userId === staffId) ?? null;
  const clientsRef = useRef(report.clients);
  clientsRef.current = report.clients;
  const clientName = useCallback(
    (id: string) => clientsRef.current.find((c) => c.clientId === id)?.name ?? id,
    [],
  );
  const categoriesConfig = useGridConfig(makeTeamCategoriesGridConfig, undefined);
  const clientsConfig = useGridConfig(makeTeamClientsGridConfig, { clientName });

  if (!member) {
    return <p className="text-sm text-text-tertiary">This person is not on the portfolio.</p>;
  }

  return (
    <section className="flex flex-col gap-4">
      <MemberCapacity member={member} progress={report.progress} isMe={member.userId === meId} />
      <DataGrid<TeamCategoryRow> config={categoriesConfig} rows={teamCategoryRows(member)} />
      {!member.split && (
        <p className="text-sm text-text-tertiary">
          No capacity split for this month, so all {formatHours(member.capacity.netHours)} count as
          client work.
        </p>
      )}
      <DataGrid<TeamClientRow> config={clientsConfig} rows={member.clientBreakdown} />
    </section>
  );
}
